import { render, staticRenderFns } from "./IbQuickTourButton.vue?vue&type=template&id=5403177c"
import script from "./IbQuickTourButton.vue?vue&type=script&lang=js"
export * from "./IbQuickTourButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports